import React from "react";
import Icon from "../atoms/Icon";
import { markdownToJSX } from "../../util/transforms";
import { getCurrentLocale } from "../../api/index";
import { getLocaleInfo } from "../../util/contentModelToData";

export default ({ title, placeholder }) => {
    const { name, newsLetterGroupId } = getLocaleInfo(getCurrentLocale());

    return (
        <div className="m-newsletter">
            <Icon className="a-icon a-icon--l a-icon--red" iconName="icon-mail"/>
            <p className="m-newsletter__title">{ markdownToJSX(title) }</p>
            <div className="m-newsletter__field" id="mc_embed_signup">
                <form
                    action="https://lapointcamps.us10.list-manage.com/subscribe/post?u=aff75a4a56cb11b862c194140&amp;id=61952b3520"
                    method="post"
                    id="mc-embedded-subscribe-form"
                    name="mc-embedded-subscribe-form"
                    className="validate"
                    target="_blank"
                    noValidate
                >
                    <div id="mc_embed_signup_scroll">
                        <div className="mc-field-group">
                            <label className="u-visually-hidden" htmlFor="mce-EMAIL">{ placeholder }</label>
                            <input
                                className="required email"
                                id="mce-EMAIL"
                                type="email"
                                name="EMAIL"
                                placeholder={ placeholder }
                            />
                        </div>
                        <div id="mce-responses" className="clear">
                            <div className="response" id="mce-error-response" style={ { display: "none" } }>
                            </div>
                            <div className="response" id="mce-success-response" style={ { display: "none" } }>
                            </div>
                        </div>
                        <div style={ { display: "none" } }>
                            <input
                                type="checkbox"
                                defaultValue={ newsLetterGroupId }
                                name={ "group[1649][" + newsLetterGroupId + "]" }
                                id={ "mce-group[1649][" + newsLetterGroupId + "]" }
                                defaultChecked
                            />
                            <label htmlFor={ "mce-group[1649][" + newsLetterGroupId + "]" }>{ name }</label>
                        </div>
                        <div style={ { position: "absolute", left: "-5000px" } } aria-hidden="true">
                            <input
                                type="text"
                                name="b_aff75a4a56cb11b862c194140_61952b3520"
                                tabIndex="-1"
                                defaultValue=""
                            />
                        </div>
                        <input
                            className="button u-visually-hidden u-visually-hidden--element"
                            type="submit"
                            defaultValue="Subscribe"
                            name="subscribe"
                            id="mc-embedded-subscribe"
                        />
                    </div>
                </form>
            </div>
        </div>
    )
};